import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
// import { ILoginResponse } from "./types";
import { UserManagementApiUrl } from "environment/routeSettings";
import { TUser } from "contexts/auth/types";
import { netCall } from "utils/netCall";
import { TResponseCode } from "utils/netCall/types";

// import { api } from "@/utils/apiClient/lib/networkCall";

// interface User {
//   name: string;
//   email: string;
//   isAdmin: boolean;
//   accessiblePages?: string[];
// }

interface AuthContextType {
  user?: TUser;
  loading: boolean;
  // localLoading: boolean;
  // logIn?: (
  //   email: string,
  //   password: string,
  //   captchaToken: string
  // ) => Promise<void>;
  // twoStepLogIn?: (authCode: string, token: string) => Promise<void>;
  // activeLoading?: (status: boolean) => void;
  logOut?: () => Promise<void>;
  // getUserProfile?: () => Promise<void>;
  // setClientNameId?: (id: string, name: string) => Promise<void>;
  // getPagePermission?: <T extends ITesBase>(
  //   editRoles: string[],
  //   indata: T
  // ) => PagePermission;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<TUser>();
  const [userLoading, setUserLoading] = useState(true);
  const [claimLoading, setClaimLoading] = useState(true);
  // const [localLoading, setLocalLoading] = useState(false);
  // const history = useNavigate();
  // const [selectedClineNameId, setSelectedClineNameId] = useState<INameId>();
  // const location = useLocation();

  // const twoStepLogIn = useCallback(async (authCode: any, token: any) => {
  //   const postObj = {
  //     AuthCode: authCode,
  //     Token: token,
  //   };
  //   try {
  //     const response = await axios.post(
  //       AuthApiUrl() + "/api/user/SetupTwoFactor",
  //       postObj,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const res = await response;
  //
  //     if (res.status === 200) {
  //       const loginResponse: ILoginResponse = res.data;
  //       if (loginResponse.responseCode === ResponseCode.TwoFactorIsNotValid) {
  //         alert("Two step code is not valid");
  //         // notify(t("twoStepCodeNotValid"), "error", 5000);
  //         // return {
  //         //   isOk: false,
  //         // };
  //       }
  //       if (loginResponse.responseCode === ResponseCode.OK) {
  //         localStorage.setItem("tesToken", loginResponse.token);
  //       }
  //     }
  //   } catch (ex) {
  //     alert("An error occurred during two-step login");
  //     // notify(t("usernamePassworsNotValid"), "error", 5000);
  //     // return {
  //     //   isOk: false,
  //     // };
  //   }
  // }, []);

  // const logIn = useCallback(
  //   async (email: any, password: any, captchaToken: any) => {
  //     const postObj = {
  //       Username: email,
  //       Password: password,
  //       CaptchaToken: captchaToken,
  //     };
  //
  //     try {
  //       const response = await axios.post(
  //         AuthApiUrl() + "/api/auth/Login",
  //         postObj,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       const res = await response;
  //       if (res.status === 200) {
  //         const loginResponse: ILoginResponse = res.data;
  //
  //         if (loginResponse.responseCode === ResponseCode.CaptchaIsNotValid) {
  //           alert("Captcha is not valid");
  //           // notify(t("captchaIsNotValid"), "error", 5000);
  //           // return {
  //           //   isOk: false,
  //           // };
  //         }
  //
  //         if (
  //           loginResponse.responseCode === ResponseCode.UsernamePasswordNotValid
  //         ) {
  //           alert("Username or password is not valid");
  //           // notify(t("usernamePassworsNotValid"), "error", 5000);
  //           // return {
  //           //   isOk: false,
  //           // };
  //         }
  //
  //         if (loginResponse.responseCode === ResponseCode.OK) {
  //           // if (loginResponse.setupTwoFactor === true) {
  //           //   //Go to Setup Two Step
  //           //   router.push(
  //           //     "/setupTwoStep/" +
  //           //       loginResponse.token +
  //           //       "/" +
  //           //       encodeURIComponent(loginResponse.qrCodeSetupImageUrl) +
  //           //       "/" +
  //           //       loginResponse.manualEntryKey
  //           //   );
  //           //   // history(
  //           //   //   "/setupTwoStep/" +
  //           //   //     loginResponse.token +
  //           //   //     "/" +
  //           //   //     encodeURIComponent(loginResponse.qrCodeSetupImageUrl) +
  //           //   //     "/" +
  //           //   //     loginResponse.manualEntryKey
  //           //   // );
  //           // }
  //           // if (loginResponse.resetPassword === true) {
  //           //   //Go to ResetPassword
  //           //   router.push("/updatePassword/" + loginResponse.account);
  //           //   // history("/updatePassword/" + loginResponse.account);
  //           // }
  //           // if (
  //           //   loginResponse.setupTwoFactor === false &&
  //           //   loginResponse.twoFactorEnabled === true
  //           // ) {
  //           //   //Go to Two Step Form
  //           //   router.push("/twoStep/" + loginResponse.token);
  //           //   // history("/twoStep/" + loginResponse.token);
  //           // }
  //           // if (
  //           //   loginResponse.setupTwoFactor === false &&
  //           //   loginResponse.twoFactorEnabled === false
  //           // ) {
  //           //   localStorage.setItem("tesToken", loginResponse.token);
  //           // }
  //         }
  //       }
  //     } catch (ex) {
  //       // Handle error
  //       console.error("Login error:", ex);
  //       // notify(ex, "error", 5000);
  //       // return {
  //       //   isOk: false,
  //       // };
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   },
  //   []
  // );

  const logOut = useCallback(async () => {
    const logoutUrl = localStorage.getItem("logoutUrl");
    console.log("!!logoutUrl", logoutUrl);
    if (logoutUrl) {
      window.location.replace(logoutUrl);
    }
    // RemoveData4LogOut();
    // setUser(undefined);
  }, []);

  // const getUserProfile = useCallback(async () => {
  //
  //     // const response = await axios.get(
  //     //   AuthApiUrl() + "/api/User/GetUserProfile",
  //     //   {
  //     //     headers: {
  //     //       "Content-Type": "application/json",
  //     //       // "X-CSRF": "1",
  //     //     },
  //     //   }
  //     // );
  //     // const data = response;
  //     // console.log("!!res2", response);
  //     // if (data.status === 401) {
  //     //   // logOut();
  //     // }
  //     // if (data.status === 200 && data.data.userName !== undefined) {
  //     //   setUser(data.data);
  //     //   if (!localStorage.getItem("selectedCustomerId")) {
  //     //     localStorage.setItem(
  //     //       "selectedCustomerName",
  //     //       data.data.defaultCustomerName
  //     //     );
  //     //     localStorage.setItem(
  //     //       "selectedCustomerId",
  //     //       data.data.defaultCustomerId
  //     //     );
  //     //     // setSelectedClineNameId({
  //     //     //   id: data.data.defaultCustomerId,
  //     //     //   name: data.data.defaultCustomerName,
  //     //     // });
  //     //     localStorage.setItem(
  //     //       "singleDivision",
  //     //       JSON.stringify({
  //     //         id: data.data.singleDivision.id,
  //     //         name: data.data.singleDivision.name,
  //     //       })
  //     //     );
  //     //     localStorage.setItem(
  //     //       "defaultDivisionId",
  //     //       data?.data?.singleDivision?.id ?? ""
  //     //     );
  //     //     localStorage.setItem("divisionSystem", data.data.divisionSystem);
  //     //     localStorage.setItem(
  //     //       "selectedDivisionId",
  //     //       data?.data?.singleDivision?.id ?? ""
  //     //     );
  //     //   }
  //     // } else {
  //     //   console.log("!!ERROR1");
  //     //   // logOut();
  //     // }
  //
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const getClaim = async () => {
    setClaimLoading(true);
    const res = await netCall<any>({
      method: "GET",
      endPoint: "/bff/user",
    });
    // alert(res);
    if (res.responseCode === TResponseCode.OK && res.results?.length > 0) {
      const logoutUrl = res.results.find(
        (claim: any) => claim.type === "bff:logout_url"
      );
      localStorage.setItem("logoutUrl", logoutUrl.value);
      setClaimLoading(false);
      console.log("!!resClaim", res);
    }
  };

  const getUserProfile = useCallback(async () => {
    setUserLoading(true);
    const res = await netCall<TUser>({
      endPoint: `${UserManagementApiUrl()}/api/SamaUser/GetUserProfile`,
      method: "GET",
    });
    console.log("!!res", res);
    if (res.responseCode === TResponseCode.OK) {
      setUser(res.results);
    }
    //TODO remove following line
    // setUser({
    //   id: "eawsdx",
    //   userName: "mhm",
    //   isAdmin: true,
    // });
    setUserLoading(false);
    setClaimLoading(false);
  }, []);

  useEffect(() => {
    getClaim();
    getUserProfile();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading: userLoading || claimLoading,
        // logIn,
        logOut,
        // getUserProfile,
        // activeLoading,
        // twoStepLogIn,
        // getPagePermission,
        // localLoading,
        // setClientNameId,
        // selectedClineNameId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};

// const fetchClaims = async () =>
//   axios.get("/bff/user", config).then((res) => res.data);
//
// function useClaims() {
//   return useQuery(claimsKeys.claim, async () => fetchClaims(), {
//     staleTime: Infinity,
//     cacheTime: Infinity,
//     retry: false,
//   });
// }
//
// export { useClaims as default };
// const { data: claims, isLoading } = useClaims();
// let nameDict =
//   claims?.find((claim: any) => claim.type === "name") ||
//   claims?.find((claim: any) => claim.type === "sub");
// let username = nameDict?.value;
// let logoutUrl = claims?.find((claim: any) => claim.type === "bff:logout_url");
//
// const compactViewModel: boolean =
//   (
//     JSON.parse(
//       localStorage.getItem("GeneralUISetting") || '{"viewMode":"normal"}'
//     ) || {}
//   ).viewMode === "compact";
//
// if (isLoading || loading) return <LoadPanel visible={true} />;
//
// if (username && user) {
//   localStorage.setItem("logoutUrl", logoutUrl.value);
//   return (
//     <div
//       className={`app ${screenSizeClass}  ${
//         compactViewModel ? "compactStyle" : ""
//       }`}
//     >
//       <Content />
//     </div>
//   );
// }
